export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-06.jpg'),
        title: '区块链',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '高级加密存储技术',
      description: `<p style="font-size:1.05rem">区块链是一种新的计算机技术，用于各种应用，如分布式数据存储，点对点传输，共识机制和加密算法。 区块链系统是开放和独立的，将以前的“对人类的信任”改为“信任机器”。 虽然区块链系统是开放的，但区块链中存储的数据是稳定可靠的。 因此，新的区块链模型可以解决传统行业的弊端，如物流，金融，保险，公共网络等，需要大量复杂的协同沟通，导致缺乏透明度，无法细分。 商业。 区块链技术将节省时间和金钱成本，为您的企业创造更多利益。</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-06.jpg')+`)"></span>
      <span>由于我们的高级研发团队，Maesinfo探索了尖端的区块链技术。 我们多年的计算机技术服务经验将用于新的基于区块链的商业模式。 我们将紧密结合各行业的发展，为企业和用户提供区块链集成解决方案，如区块链技术服务，商业计划信息，区块链生态共建等。 </span>`
    }
  ]
}
